import React, { Component } from 'react';
import Home from '../Components/Home/Home';
import Showcase from '../Components/Showcase/Showcase';
import Bragging from '../Components/Bragging/Bragging';
import Videos from '../Components/Videos/Videos';
import Seo from '../Components/Seo/Seo';
import { Route, Routes } from 'react-router-dom';

/**
 * Class to define routes in a single place
 */
export default class AppRoutes extends Component {
    render() {
        return (
            <>
                <Seo />
                <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/showcase' element={<Showcase />} />
                    <Route path='/bragging-rights' element={<Bragging />} />
                    <Route path='/videos' element={<Videos />} />
                </Routes>
            </>
        )
    }
}